import { safeApiRequest } from './apiClient';

const BASE = '/api/admin/todos';

export const fetchAdminTodos = async () => {
  return safeApiRequest(BASE, {
    method: 'GET',
    skipCsrf: true,
  });
};

export const createAdminTodo = async (baslik) => {
  return safeApiRequest(BASE, {
    method: 'POST',
    body: { baslik },
  });
};

export const bootstrapAdminTodos = async () => {
  return safeApiRequest(`${BASE}/bootstrap`, {
    method: 'POST',
  });
};

export const completeAdminTodo = async (id, tamamlanmaNotu) => {
  return safeApiRequest(`${BASE}/${id}/tamamla`, {
    method: 'PATCH',
    body: { tamamlanmaNotu: tamamlanmaNotu != null ? tamamlanmaNotu : '' },
  });
};

export const reopenAdminTodo = async (id) => {
  return safeApiRequest(`${BASE}/${id}/yeniden-ac`, {
    method: 'PATCH',
  });
};

export const deleteAdminTodo = async (id) => {
  return safeApiRequest(`${BASE}/${id}`, {
    method: 'DELETE',
  });
};
